import React from 'react'
import MinusSVG from "../../../assets/icons/decrease-serving.svg"

export const MinusIcon: React.FC = () => {
  return (
    <img src={MinusSVG} alt="" className="w-[17.8px] h-[17.8px] cursor-pointer" />
  )
}
